/**
 * Version numbers in canonical IDs (openspec change `model-picking`, D3), shared by the catalogue
 * sync and the catalogue: no generated import.
 */

/**
 * The dotted version in a canonical ID (D3): `anthropic/claude-sonnet-5-5` → [5, 5],
 * `anthropic/claude-sonnet-5` → [5], `openai/gpt-6.1-sol` → [6, 1]; a trailing date suffix
 * (`claude-haiku-4-5-20251001`) is ignored. Parts are the short numeric groups after the family
 * name, dash- or dot-separated.
 */
export function parsedVersion(canonicalId: string, family?: string): number[] {
  const name = canonicalId.slice(canonicalId.indexOf("/") + 1);
  const rest = family && name.startsWith(`${family}-`) ? name.slice(family.length + 1) : name;
  const parts: number[] = [];
  for (const part of rest.split("-")) {
    // A date (8 digits) or any longer group ends the version.
    if (!/^\d{1,3}(\.\d{1,3})*$/.test(part)) {
      if (parts.length > 0) {
        break;
      }
      continue;
    }
    parts.push(...part.split(".").map(Number));
  }
  return parts;
}

export function compareParts(a: readonly number[], b: readonly number[]): number {
  for (let i = 0; i < Math.max(a.length, b.length); i++) {
    const d = (a[i] ?? 0) - (b[i] ?? 0);
    if (d !== 0) {
      return d;
    }
  }
  return 0;
}
